export function useLabel() {
  function getLabelClass(isRequired: boolean): string[] {
    if (isRequired) {
      return ['tw-font-bold', "after:tw-content-['*']", 'after:tw-ml-0.5']
    }
    return []
  }

  return { getLabelClass }
}
